import { render } from "./PatientChartsSummaryTable.vue?vue&type=template&id=d47db554"
import script from "./PatientChartsSummaryTable.vue?vue&type=script&lang=js"
export * from "./PatientChartsSummaryTable.vue?vue&type=script&lang=js"

import "./PatientChartsSummaryTable.vue?vue&type=style&index=0&id=d47db554&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__